import {isMobile} from 'react-device-detect';

/**
 * the widest viewport we still treat as mobile. 768px is the breakpoint this app's own styles are
 * written against - by far the most used max-width in the styled components here.
 * */
export const MOBILE_MAX_WIDTH = 768;

/**
 * "is this a mobile view", rather than react-device-detect's "is this a mobile device".
 *
 * the two are not the same, and the size is the more telling of the two: a desktop browser in a
 * narrow window gets the mobile layout while reporting a desktop user agent, and that is the view
 * the manager is actually looking at. the device check is still there to catch the other direction
 * - a phone held sideways is wider than the breakpoint and is still a phone - so either signal on
 * its own is enough.
 *
 * this is a point in time answer. callers that have to react to the window being resized need their
 * own listener on top of it.
 *
 * @return {boolean}
 * */
export function isMobileView() {
    const viewportWidth = window.innerWidth || document.documentElement?.clientWidth;
    // no width to go on (very old browsers) - fall back to the device alone rather than read 0 as narrow
    return isMobile || (viewportWidth > 0 && viewportWidth <= MOBILE_MAX_WIDTH);
}
